class Cart {
    constructor() {
        var self = this;
        // Keep cart contents always up to date
        const $cartResult = $(".cart-result");

        if (1 == $cartResult.length) {
            var data = {
                action: "wc_get_cart_count"
            };

            jQuery.post(wc_add_to_cart_params.ajax_url, data, function (
                response
            ) {
                if (response) {
                    $cartResult.html(response);
                }
            });
        }



        self.checkMaxAmount();
        //activate tooltip
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });

        // Add count
        $(document.body).on("added_to_cart", function (
            event,
            fragments,
            cart_hash,
            $button
        ) {
            self.updateCartBadge(fragments.cart_count);
        });

        // Intercept add to cart
        $(document).on("click", ".single_add_to_cart_button", function (e) {
            e.preventDefault();

            var form = $(this).closest("form.cart");
            var $submitBtn = $(this);

            var formData = {
                product_sku: "",
                product_id: form.find("[name=product_id]").val(),
                variation_id: form.find("[name=variation_id]").val(),
                quantity: form.find("[name=quantity]").val(),
                action: "wc_ajax_add_to_cart"
            };

            $submitBtn.css("pointer-events", "none").css("opacity", "0.7");
            $submitBtn.addClass("wc-button-loading");

            $.ajax({
                url: wc_add_to_cart_params.ajax_url,
                type: "POST",
                processData: true,
                data: formData,
                success: function (response) {
                    if (response.error & response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(".woocommerce-notices-wrapper").remove();
                        $(document.body).trigger("added_to_cart", [
                            response.fragments,
                            response.cart_hash,
                            $submitBtn
                        ]);
                    }

                    $submitBtn.css("pointer-events", "all").css("opacity", "1");
                    $submitBtn.removeClass("wc-button-loading");

                    // Remove existing notices
                    $(
                        ".woocommerce-error, .woocommerce-message, .woocommerce-info"
                    ).remove();

                    // Add new notices
                    form.closest(".product").before(
                        response.fragments.notices_html
                    );
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    //console.log(jqXHR);
                    //console.log(textStatus);
                    //console.log(errorThrown);
                }
            });

            return false;
        });

        // Clear cart
        $(document).on("click", ".clear-cart", function (e) {
            var data = {
                action: "empty_cart"
            };

            jQuery(".cart-wrapper").LoadingOverlay("show", {
                imageClass: "jquery-loading-overlay-icon",
                image: ajax.templateUrl + "/assets/svg/loading.svg",
                imageResizeFactor: 1,
                background: "rgba(255, 255, 255, 0.5)"
            });

            jQuery.post(wc_add_to_cart_params.ajax_url, data, function (
                response
            ) {
                window.location.reload();
            });
        });

        // Add article manually
        $(".add-custom-art")
            .removeClass("d-none")
            .fadeIn();

        $(document).on(
            "focus",
            '.add-custom-art .input-text[name="article_number_add"]',
            function (e) {
                $(this)
                    .removeClass("input-error")
                    .closest(".add-custom-art")
                    .find(".error-response-txt")
                    .fadeOut();
            }
        );

        $(document).on(
            "click",
            '.add-custom-art button[type="submit"]',
            function (e) {
                e.preventDefault();

                const elem = $(this).closest(".add-custom-art");
                const locale = elem.data("locale");
                const isEmpty = elem.data("is-empty");
                const search = elem.find(".search").val();

                var $submitBtn = $(this);

                if (!search) {
                    $submitBtn.prev().addClass("input-error");
                    return;
                }

                var formData = {
                    search: search,
                    locale: locale,
                    action: "wc_ajax_add_variation_to_cart"
                };

                $submitBtn.addClass("disabled");
                $submitBtn.addClass("wc-button-loading-relative");
                $submitBtn.prev().addClass("disabled");

                $.ajax({
                    url: wc_add_to_cart_params.ajax_url,
                    type: "POST",
                    processData: true,
                    data: formData,
                    success: function (response) {
                        if (response.fragments) {
                            $(document.body).trigger("added_to_cart", [
                                response.fragments,
                                response.cart_hash,
                                $submitBtn
                            ]);

                            // Remove existing notices
                            $(
                                ".woocommerce-error, .woocommerce-message, .woocommerce-info"
                            ).remove();

                            // Add new notices
                            elem.closest(".cart-wrapper").before(
                                response.fragments.notices_html
                            );

                            // Refresh view
                            self.refreshCartContents("update");

                            // Refresh if we're empty
                            if (isEmpty) {
                                window.location.reload();
                            }
                        } else {
                            $submitBtn.prev().addClass("input-error");
                            elem.find(".article-group").after(
                                '<div class="error-response-txt my-2 text-frost-berry">' +
                                response.data ?? "" + "</div>"
                            );
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        //console.log(jqXHR);
                        //console.log(textStatus);
                        //console.log(errorThrown);
                    },
                    complete: function () {
                        $submitBtn.removeClass("disabled");
                        $submitBtn.removeClass("wc-button-loading-relative");
                        $submitBtn.prev().removeClass("disabled");
                    }
                });

                return false;
            }
        );

        // Alter product item quantity
        $(document).on(
            "click",
            ".grouped-quantity-input button.plus, .grouped-quantity-input button.minus",
            function (e) {
                var qty = $(this)
                    .parent()
                    .find(".qty");
                var val = parseFloat(qty.val());
                var max = parseFloat(qty.attr("max"));
                var min = parseFloat(qty.attr("min"));
                var step = parseFloat(qty.attr("step"));

                if ($(this).is(".plus")) {
                    if (max && max <= val) {
                        qty.val(max);
                    } else {
                        qty.val(val + step);
                    }
                } else {
                    if (min && min >= val) {
                        qty.val(min);
                    } else if (1 < val) {
                        qty.val(val - step);
                    }
                }

                qty.trigger("keyup");
            }
        );

        $(document).on(
            "keyup",
            ".wishlist-wrapper .grouped-quantity-input .qty",
            function (e) {
                $(document.body).trigger("wishlist_product_quantity_update", {
                    element: $(this)
                });
            }
        );

        // Remove cart item
        $(document).on(
            "click",
            ".woocommerce-cart-form .cart_item .remove",
            function (e) {
                e.preventDefault();

                var product_id = $(this).data("product_id");
                var product_sku = $(this).data("product_sku");
                var cart_item_key = $(this).data("cart_item_key");

                var contents = {
                    action: "remove_product",
                    sku: product_sku,
                    product_id: product_id,
                    cart_item_key: cart_item_key
                };

                self.refreshCartContents(contents);
            }
        );

        // Cart quantity trigger
        $(document).on(
            "keyup",
            ".woocommerce-cart .grouped-quantity-input input.qty",
            function (e) {
                var qty = $(this)
                    .parent()
                    .find(".qty");

                var val = parseFloat(qty.val());
                var min = parseFloat(qty.attr("min"));
                var step = parseFloat(qty.attr("step"));

                if (val < min) {
                    val = min;
                }

                if (step !== 1 && val % step != 0) {
                    var absValue = Math.abs(val);
                    step = Math.abs(step);

                    var low = absValue - (absValue % step);
                    var high = low + step;

                    var result = absValue - low < high - absValue ? low : high;
                    val = result * Math.sign(val);
                }

                $(this).val(val);

                var cartKey = $(this)
                    .closest(".grouped-quantity-input")
                    .find(".cart-item-key")
                    .val();

                var contents = {
                    action: "update_qty",
                    cart_item_key: cartKey,
                    quantity: val
                };

                self.refreshCartContents(contents);
            }
        );
    }
    checkMaxAmount() {
        let maxAmount = parseFloat($('.cart-header').data('maxamount'));
        let cartTotal = parseFloat($('.order-total .woocommerce-Price-amount.amount').text().replace(/[^0-9.]/g, ''));

        if (maxAmount && (cartTotal > maxAmount)) {
            $('.wc-proceed-to-checkout').addClass('disabled');
            $(".woocommerce-notices-wrapper").html('<div class="woocommerce-notices-wrapper exceeded-max-amount"><ul class="woocommerce-error" role="alert"><li>Du har överskridit ditt maxbelopp, vänligen kontakta GPA om du vill att ditt maxbelopp ska höjas. </li></ul></div>');
        } else if (maxAmount && (cartTotal <= maxAmount)) {
            $('.wc-proceed-to-checkout').removeClass('disabled');
            $(".woocommerce-notices-wrapper").find('.exceeded-max-amount').remove();

        }
    }
    updateCartBadge(cart_count) {
        let $badge_html = $(".header-buttons .cart-menu-wrapper .badge");

        $badge_html.html(cart_count);

        if (0 == cart_count) {
            $badge_html.removeClass("d-block");
        } else {
            $badge_html.removeClass("d-block").addClass("d-block");
        }
    }

    refreshCartContents(data) {
        var self = this;

        var contents = "undefined" === typeof data ? "update" : data;
        var $cart_form = $(".woocommerce-cart-form");

        $cart_form.LoadingOverlay("show", {
            imageClass: "jquery-loading-overlay-icon",
            image: ajax.templateUrl + "/assets/svg/loading.svg",
            imageResizeFactor: 1,
            zIndex: 800,
            background: "rgba(255, 255, 255, 0.5)"
        });

        $.ajax({
            type: "POST",
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: "wc_cart_actions",
                nonce: ajax.nonce,
                contents: contents
            }

            //timeout: 3000
        }).done(function (response) {
            $cart_form.LoadingOverlay("hide", true);

            self.updateCartBadge(response.fragments.cart_count);

            if (response.fragments.cart_html) {
                $.each(response.fragments.cart_html, function (key, contents) {
                    var $container = $("." + key);

                    if ($container.length) {
                        $container.html(contents.data);
                    }
                });

                $(".add-custom-art")
                    .removeClass("d-none")
                    .fadeIn();

                self.checkMaxAmount();

            }
        }, "JSON");

        return false;
    }
}

export default Cart;
